import UILink from '@components/ui/UILink'
import { Box } from '@mui/joy'
import { DOMNode, Element, domToReact } from 'html-react-parser'

interface JchLinkProps {
	dom: Element
}

const JchLink = ({ dom }: JchLinkProps) => {
	const {
		attribs: { class: className, 'data-href': href },
	} = dom
	return (
		<Box className={className} {...{ component: UILink, href }}>
			{domToReact(dom.children as Array<DOMNode>)}
		</Box>
	)
}
export default JchLink
